<template>
  <div class="top-bar-container">
    <wrap-container class="w100">
      <div class="inner-container">
        <div class="logo">
          <img src="@/assets/img/logo.svg" alt="BBVA" />
        </div>
        <div class="modulo">
          <p v-safe-html="config.modulo" />
        </div>
      </div>
    </wrap-container>
    <progress-bar />
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import ProgressBar from "@/components/core/ProgressBar";

export default {
  name: "TopBar",
  components: { WrapContainer, ProgressBar }
};
</script>

<style scoped>
div.top-bar-container {
  background: #072146;
  color: white;
  position: fixed;
  width: 100%;
  z-index: 9999;
  padding: 0 17px;
}

div.inner-container {
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  max-width: 940px;
}

div.logo img {
  height: 25px;
}

div.modulo {
  text-align: right;
}

p {
  font-size: 16px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  margin: 0;
}

@media screen and (max-width: 420px) {
  div.logo img {
    height: 13px;
  }
  p {
    font-size: 12px;
  }
  div.inner-container {
    height: 48px;
  }
}
</style>
